import { Component, Inject, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, timer } from 'rxjs';
import { debounceTime, take, takeUntil } from 'rxjs/operators';
import { modules } from 'src/app/globals';
import { QuillNoteTypeMismatchDialogComponent } from 'src/app/lib/shared/components/dialog/quill-note-type-mismatch-dialog/quill-note-type-mismatch-dialog.component';
import { DOUBLET_PROVIDER_SERVICE, IDoubletProviderService } from 'src/app/lib/shared/interfaces';
import { Customer } from '../../../classes';
import { CUSTOMER_PROVIDER_SERVICE, ICustomerProviderService } from '../../../interfaces';
import { CustomerService } from '../../../services/customer.service';

@Component({
  selector: 'app-customer-form',
  templateUrl: './customer-form.component.html',
  styleUrls: ['./customer-form.component.css']
})
export class CustomerFormComponent implements OnDestroy, OnInit {

  @Input() editMode: boolean = true;
  @Input() showIdGenerator: boolean = true;
  @Input() appearance: 'standard' | 'fill' | 'outline' = 'fill';

  formGroup: FormGroup;

  modules = modules;

  private _subscriptions: Subscription[] = [];

  constructor(
    @Optional() @Inject(DOUBLET_PROVIDER_SERVICE) public doubletService: IDoubletProviderService,
    @Optional() @Inject(CUSTOMER_PROVIDER_SERVICE) private _customerProviderService: ICustomerProviderService,
    private _controlContainer: ControlContainer,
    private _customerService: CustomerService,
    private _dialog: MatDialog
  ) { }

  clearName(){
    this.formGroup.controls['customername'].setValue(null);
    this._customerProviderService.customer$.pipe(take(1))
      .subscribe((customer: Customer) => {
        this.formGroup.controls['customername'][this.formGroup.controls['customername'].value === customer.customername? 'markAsPristine': 'markAsDirty']();
      });
  }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as FormGroup;

    if (this.doubletService) this._subscriptions.push(this.customerNameControl.valueChanges.pipe(debounceTime(1000)).subscribe(value => {
      this.doubletService.setSearchString(value);
    }));

    this._subscriptions.push(...[
      this.customerNoteControl.valueChanges.pipe(take(1), takeUntil(timer(2000))).subscribe((note: string) => {
        if(typeof note !== 'string') return;
        if (note.startsWith('{"ops":[{')) {
          this._dialog.open(QuillNoteTypeMismatchDialogComponent, {
            panelClass: 'no-padding-dialog-container',
            data: note
          }).afterClosed().subscribe((htmlResult: string) => {
            if (htmlResult) {
              this.customerNoteControl.setValue(htmlResult);
              this.customerNoteControl.markAsDirty();
            }
          });
        }
      })
    ]);

    this.setValidators();
  }

  setAutoCustomerNumber() {
    this._customerService.getNextCustomerNumber().subscribe((number: string) => this.customerNumberControl.setValue(number));
  }

  setValidators() {
    this.customerNumberControl.setValidators(Validators.compose([Validators.required, Validators.pattern(/^\d{7}$/)]));
  }

  get customerNameControl(): AbstractControl {
    return this.formGroup.controls['customername'];
  }
  get customerNumberControl(): AbstractControl {
    return this.formGroup.controls['customernumber'];
  }
  get customerNoteControl(): AbstractControl {
    return this.formGroup.controls['customernote'];
  }

}


